import { Box, styled } from '@mui/material'
import { type ReactNode } from 'react'

interface PageCondensedProps {
  children: ReactNode
  /**
   * Bounds the wrapper to the pane instead of letting it grow with its content,
   * for a tab that scrolls a region of its own rather than scrolling whole. Off
   * below `md`, where the pane is too short to give a scrolling region anything
   * worth scrolling.
   */
  fullHeight?: boolean
}

/**
 * Content wrapper for the org detail tabs.
 *
 * The tabs render in the pane beside the org sidebar, not under the full-width app
 * header, so there is no centered column to line up with: the content fills the pane
 * and the padding alone supplies the whitespace.
 */
const StyledContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullHeight',
})<{ fullHeight: boolean }>(({ theme, fullHeight }) => ({
  width: '100%',
  padding: theme.spacing(4, 6),
  boxSizing: 'border-box',
  ...(fullHeight && {
    [theme.breakpoints.up('md')]: {
      height: '100%',
      overflow: 'hidden',
    },
  }),
}))

export const PageCondensed = ({ children, fullHeight = false }: PageCondensedProps) => (
  <StyledContent fullHeight={fullHeight}>{children}</StyledContent>
)
